module.exports = __webpack_public_path__ + "media/images/people/boy-7-909c927f3b134bcc18ecd994f3d8d432.webp";